"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const common_utils_1 = require("@zapier/common-utils");
const design_system_1 = require("@zapier/design-system");
const rootStyle = (hasIcon, canDismiss, hasRight) => core_1.css `
  border: 2px solid;
  border-radius: 10px;
  box-shadow: ${design_system_1.Shadows.elevation5};
  color: ${design_system_1.Colors.black};
  display: grid;
  grid-gap: 15px;
  grid-template-columns: ${hasIcon ? '26px ' : ''}1fr ${hasRight ? ' auto' : ''} ${canDismiss
    ? ' 22px'
    : ''};
  padding: 14px;
`;
const bodyStyle = core_1.css `
  font-size: 14px;
  line-height: 20px;
`;
const dismissStyle = core_1.css `
  height: 20px;
  margin-top: -2px;
`;
const iconStyle = core_1.css `
  height: 20px;
  margin-top: -6px;
`;
const titleStyle = core_1.css `
  font-weight: 600;
`;
const TYPES_MAP = {
    error: {
        color: 'red500',
        icon: 'alertCircle',
        styles: {
            backgroundColor: design_system_1.Colors.red000,
            borderColor: design_system_1.Colors.red500,
        },
        title: 'Bargle!',
    },
    info: {
        color: 'grey500',
        icon: 'alertInfo',
        styles: {
            backgroundColor: design_system_1.Colors.grey000,
            borderColor: design_system_1.Colors.grey500,
        },
        title: '',
    },
    success: {
        color: 'green400',
        icon: 'formCheckCircle',
        styles: {
            backgroundColor: design_system_1.Colors.green300,
            borderColor: design_system_1.Colors.green400,
        },
        title: 'Success!',
    },
    warning: {
        color: 'yellow500',
        icon: 'alertInfo',
        styles: {
            backgroundColor: design_system_1.Colors.yellow200,
            borderColor: design_system_1.Colors.yellow500,
        },
        title: 'Warning.',
    },
};
const MessageBar = (props) => {
    const type = TYPES_MAP[props.type] || TYPES_MAP.info;
    const icon = props.icon !== undefined ? props.icon : type.icon;
    const title = props.title !== undefined ? props.title : type.title;
    const canDismiss = !!props.onDismiss;
    return (common_utils_1.isolateComponent("div", { css: [rootStyle(!!icon, canDismiss, !!props.right), type.styles] },
        !!icon && (common_utils_1.isolateComponent("div", { css: iconStyle },
            common_utils_1.isolateComponent(design_system_1.Icon, { color: type.color, name: icon, size: 32 }))),
        common_utils_1.isolateComponent("div", { css: bodyStyle },
            !!title && common_utils_1.isolateComponent("strong", { css: titleStyle }, title),
            " ",
            props.children),
        props.right,
        canDismiss && (common_utils_1.isolateComponent("button", { css: dismissStyle, onClick: props.onDismiss },
            common_utils_1.isolateComponent(design_system_1.Icon, { color: type.color, name: "formX", size: 24 })))));
};
MessageBar.defaultProps = {
    type: 'info',
};
exports.default = MessageBar;
